import React from 'react';
import { Interpolate } from 'react-i18next';
import * as messageTypes from './message-types';

export default {
  [messageTypes.ASSETS_ARE_UPLOADING]: {
    content: () => <Interpolate i18nKey="post-form.uploading" useDangerouslySetInnerHTML={true} />,
    type: 'info',
  },
  [messageTypes.POST_DELETE]: {
    content: () => (
      <Interpolate i18nKey="messages.post-deleted" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_UPDATE]: {
    content: () => (
      <Interpolate i18nKey="messages.post-updated" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_INVALID]: {
    content: () => (
      <Interpolate i18nKey="messages.post-invalid" useDangerouslySetInnerHTML={true} />
    ),
    type: 'error',
  },
  [messageTypes.POST_ENABLE_COMMENTING]: {
    content: () => (
      <Interpolate i18nKey="messages.commenting-enabled" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_DISABLE_COMMENTING]: {
    content: () => (
      <Interpolate i18nKey="messages.commenting-disabled" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_PIN]: {
    content: () => <Interpolate i18nKey="messages.post-pinned" useDangerouslySetInnerHTML={true} />,
    type: 'info',
  },
  [messageTypes.POST_UNPIN]: {
    content: () => (
      <Interpolate i18nKey="messages.post-unpinned" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_ADD_TOP_COMMENT]: {
    content: () => (
      <Interpolate i18nKey="messages.post-top-comment-added" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_REMOVE_TOP_COMMENT]: {
    content: () => (
      <Interpolate i18nKey="messages.post-top-comment-removed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.USER_SUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.user-subscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.USER_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.user-unsubscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_SUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.post-subscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.post-unsubscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.POST_MOVE]: {
    content: () => <Interpolate i18nKey="messages.post-moved" useDangerouslySetInnerHTML={true} />,
    type: 'info',
  },
  [messageTypes.POST_CHANGE_CATEGORY]: {
    content: () => (
      <Interpolate i18nKey="messages.post-category-changed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },

  [messageTypes.COMMENT_UPDATE]: {
    content: () => (
      <Interpolate i18nKey="messages.comment-updated" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.COMMENT_DELETE]: {
    content: () => (
      <Interpolate i18nKey="messages.comment-deleted" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.COMMENT_INVALID]: {
    content: () => (
      <Interpolate i18nKey="messages.comment-invalid" useDangerouslySetInnerHTML={true} />
    ),
    type: 'error',
  },
  [messageTypes.REQUIRE_POST_FIELDS]: {
    content: data => {
      const key = data && data.sort().join('-');
      switch (key) {
        case 'title':
          return (
            <Interpolate i18nKey="messages.post-title-required" useDangerouslySetInnerHTML={true} />
          );
        case 'content':
          return (
            <Interpolate
              i18nKey="messages.post-content-required"
              useDangerouslySetInnerHTML={true}
            />
          );
        default:
          return (
            <Interpolate
              i18nKey="messages.post-fields-required"
              useDangerouslySetInnerHTML={true}
            />
          );
      }
    },
    type: 'error',
  },
  [messageTypes.CATEGORY_DELETE]: {
    content: () => (
      <Interpolate i18nKey="messages.category-deleted" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.CATEGORY_UPDATE]: {
    content: () => (
      <Interpolate i18nKey="messages.category-updated" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.CATEGORY_SUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.category-subscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.CATEGORY_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.category-unsubscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.CATEGORY_UNSUBSCRIBED]: {
    content: () => (
      <Interpolate i18nKey="messages.category-unsubscribed" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.CATEGORY_CREATED]: {
    content: () => (
      <Interpolate i18nKey="messages.category-created" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.MAIN_PAGE_UPDATED]: {
    content: () => (
      <Interpolate i18nKey="messages.main-page-updated" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },

  [messageTypes.DEMO_MODE_SITE]: {
    content: () => (
      <Interpolate i18nKey="messages.demo-mode-site" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.DEMO_MODE_EDITOR]: {
    content: () => (
      <Interpolate i18nKey="messages.demo-mode-editor" useDangerouslySetInnerHTML={true} />
    ),
    type: 'info',
  },
  [messageTypes.DEMO_MODE_PREVIEW]: {
    content: () => (
      <Interpolate
        i18nKey="messages.frameless-demo-mode-preview"
        useDangerouslySetInnerHTML={true}
      />
    ),
    type: 'info',
  },
};
